import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useController } from "../assets/components/BaseContrroler";

function Earning() {
  const {
    baseController: { homeController },
  } = useController();
  const { setNavbar, setUrl } = homeController;

  useEffect(() => {
    setUrl("/team");
    setNavbar(true);
  }, []);

  const teamItems: any = [
    "Our well trained staff who are certified professionals in Clearing & Forwarding will ensure the best possible on time service to our valued customers.",
    "Our aim is to satisfy our clients through a very flexible organization with experienced staff able to offer the highest possible level of service.",
    "Karnafully International has been operating in the custom clearing & forwarding sector since 2010. Our main aim has always been to satisfy the needs of all our customers by offering them personalized transport service for any volume of goods, anywhere in Bangladesh.",
  ];

  return (
    <div className="px-2" id="about">
      <div className="row align-items-center m-auto">
        {/* Text Column */}
        <div className="col-12 col-md-7 mb-4 mb-md-0">
          <div className="d-flex align-items-center mb-3">
            <img
              src={require("../assets/images/logo-team.png")}
              alt="karnafully"
              className="bg-dark p-2 me-3"
              style={{
                width: "70px",
                height: "70px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
            <h4 className="fw-bold mb-0">
              <span className="text-danger">PROFESSIONAL</span> <br /> TEAM
            </h4>
          </div>

          <ul className="teamList ps-0">
            {teamItems.map((item: any, i: any) => (
              <li className="pb-3 list-group-item border-0" key={i}>
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Image Column */}
        <div className="col-12 col-md-5 text-center">
          <img
            src={require("../assets/images/team.png")}
            alt="karnafully"
            className="img-fluid rounded shadow-sm"
            style={{
              maxWidth: "100%",
              height: "auto",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default observer(Earning);
